// extracted by mini-css-extract-plugin
module.exports = {"container":"workgroups_container__fIwD8","title":"workgroups_title__uHl_R","slider":"workgroups_slider__8udp4","list":"workgroups_list__NbAlc","item":"workgroups_item__A9mHZ"};